import { Box, Text, Select, Input } from "@chakra-ui/react";

import { Settings } from "../style";

export const SettingsBlock = ({
  id,
  handleInputChange,
  handleOptionChange,
  placeSize,
  placeHeight,
  placeSpacing,
}) => {
  let weights = {
    Thin: 100,
    ExtraLight: 200,
    Light: 300,
    Regular: 400,
    Medium: 500,
    SemiBold: 600,
    Bold: 700,
    ExtraBold: 800,
    Black: 800,
  };

  let myData = [];

  const weight = Object.keys(weights);

  let data = localStorage.getItem("FontFamilies");
  let dataArr;
  data
    ? (dataArr = JSON.parse(data))
    : (dataArr = [
        { id: 0, num: 1, cardName: "Primary", cardValue: "Nunito" },
        { id: 1, num: 2, cardName: "Secondary", cardValue: "Roboto" },
      ]);
  for (let i = 0; i < dataArr.length; i++) {
    myData.push(dataArr[i]);
  }

  return (
    <Settings
      mt={"32px"}
      justifyContent={{
        base: "space-between",
        md: "space-between",
        lg: "space-between",
      }}
      flexWrap="wrap"
      key={id}
    >
      {/** Font Family Selection */}
      <Box
        minW={{ base: "80px", md: "80px", lg: "150px" }}
        maxW={{ base: "80px", md: "80px", lg: "150px" }}
      >
        <Text
          className="title"
          fontSize={{ base: "15px", md: "15px", lg: "18px" }}
          fontWeight="medium"
        >
          Family
        </Text>
        <Select
          variant="flushed"
          key="fonFam"
          name="fonFam"
          placeholder="Fonts"
          fontSize={{ base: "14px", md: "14px", lg: "16px" }}
          color="#7d7d7d"
          onChange={handleOptionChange}
        >
          {myData.map((val) => {
            return <option value={val.cardValue}>{val.cardName}</option>;
          })}
        </Select>
      </Box>

      {/** Size Selection */}
      <Box
        minW={{ base: "80px", md: "80px", lg: "150px" }}
        maxW={{ base: "80px", md: "80px", lg: "150px" }}
      >
        <Text
          className="title"
          fontSize={{ base: "15px", md: "15px", lg: "18px" }}
          fontWeight="medium"
        >
          Size
        </Text>
        <Input
          variant="flushed"
          key="fonSize"
          name="fonSize"
          fontSize={{ base: "14px", md: "14px", lg: "16px" }}
          placeholder={placeSize}
          onChange={handleInputChange}
        />
      </Box>

      {/** LINE HEIGHT Selection */}
      <Box
        minW={{ base: "80px", md: "80px", lg: "150px" }}
        maxW={{ base: "80px", md: "80px", lg: "150px" }}
      >
        <Text
          className="title"
          fontSize={{ base: "15px", md: "15px", lg: "18px" }}
          fontWeight="medium"
        >
          Line Height
        </Text>
        <Input
          variant="flushed"
          key="fonHeight"
          name="fonHeight"
          fontSize={{ base: "14px", md: "14px", lg: "16px" }}
          placeholder={`${placeHeight}px`}
          onChange={handleInputChange}
        />
      </Box>

      {/** LETTER SPACING Selection */}
      <Box
        minW={{ base: "130px", md: "100px", lg: "150px" }}
        maxW={{ base: "130px", md: "100px", lg: "150px" }}
        mt={{ base: "30px", md: 0, lg: 0 }}
      >
        <Text
          className="title"
          fontSize={{ base: "15px", md: "15px", lg: "18px" }}
          fontWeight="medium"
        >
          Letter Spacing
        </Text>
        <Input
          variant="flushed"
          key="fonSpacing"
          name="fonSpacing"
          fontSize={{ base: "14px", md: "14px", lg: "16px" }}
          placeholder={`${placeSpacing}%`}
          onChange={handleInputChange}
        />
      </Box>

      {/** WEIGHT Selection */}
      <Box
        minW={{ base: "140px", md: "80px", lg: "150px" }}
        maxW={{ base: "140px", md: "80px", lg: "150px" }}
        mt={{ base: "30px", md: 0, lg: 0 }}
        // mr={{ base: "5px", md: null, lg: null }}
      >
        <Text
          className="title"
          fontSize={{ base: "15px", md: "15px", lg: "18px" }}
          fontWeight="medium"
        >
          Weight
        </Text>
        <Select
          variant="flushed"
          key="fonWeight"
          name="fonWeight"
          placeholder="Weights"
          fontSize={{ base: "14px", md: "14px", lg: "16px" }}
          color="#7d7d7d"
          onChange={handleOptionChange}
        >
          {weight.map((val) => {
            return <option value={weights[val]}>{val}</option>;
          })}
        </Select>
      </Box>
    </Settings>
  );
};
